<template>
  <el-drawer size="1400px" :title="model.title" :visible="visible" :before-close="closeDialog"
    class="isp-task-detail-drawer" :append-to-body="true">
    <div class="info-content">
      <div class="info-content-box">
        <div class="info-box">
          <div class="title">{{ $t('dms_task_detail_drawer.ji_ben_xin_xi') }}</div>
          <ul class="information">
            <li class="line">
              {{ $t('dms_task_detail_drawer.ren_wu_ming_cheng') }}
              <span class="right">{{ taskInfo.taskName || '-' }}</span>
            </li>
            <li class="line">
              {{ $t('dms_task_detail_drawer.ren_wu_lei_xing') }}
              <span class="right">
                {{ getDicValue('dms_sim_task_type', taskInfo.taskType) || '-' }}
              </span>
            </li>
            <li class="line">
              {{ $t('dms_task_detail_drawer.ren_wu_lai_yuan') }}
              <span class="right">{{ getDicValue('iot_cmd_task_source', taskInfo.taskSource) || '-' }}</span>
            </li>
            <li class="line">
              {{ $t('dms_task_detail_drawer.gyszh') }}
              <span class="right">{{ taskInfo.supplierAccount || '-' }}</span>
            </li>
            <li class="line">
              {{ $t('dms_task_detail_drawer.gong_ying_shang') }}
              <span class="right">{{ taskInfo.supplierName || '-' }}</span>
            </li>
          </ul>
          <p class="device-num">
            {{ $t('dms_task_detail_drawer.SIMka_shu_liang') }}
            <span>{{ taskInfo.taskTotalNum || 0 }}</span>
          </p>
          <div class="device">
            <li class="line">
              <span class="l" :title="$t('dms_task_detail_drawer.wei_zhi_xing')">
                {{ $t('dms_task_detail_drawer.wei_zhi_xing') }}
              </span>
              <span class="progress">
                <el-progress :percentage="(taskInfo.taskWaitNum / taskInfo.taskTotalNum) * 100" :format="progressFormat"
                  color="#F9C851"></el-progress>
              </span>
              <span class="right">{{ taskInfo.taskWaitNum || 0 }}</span>
            </li>
            <li class="line">
              <span class="l" :title="$t('dms_task_detail_drawer.zhi_xing_zhong')">
                {{ $t('dms_task_detail_drawer.zhi_xing_zhong') }}
              </span>
              <div class="progress">
                <el-progress :percentage="(taskInfo.taskExecutingNum / taskInfo.taskTotalNum) * 100" color="#37B8E0"
                  :format="progressFormat"></el-progress>
              </div>
              <span class="right">{{ taskInfo.taskExecutingNum || 0 }}</span>
            </li>
            <li class="line">
              <span class="l" :title="$t('dms_task_detail_drawer.zhi_xing_cheng_gong')">
                {{ $t('dms_task_detail_drawer.zhi_xing_cheng_gong') }}
              </span>
              <span class="progress">
                <el-progress :percentage="(taskInfo.taskSuccessNum / taskInfo.taskTotalNum) * 100"
                  :format="progressFormat" color="#0D9AE0"></el-progress>
              </span>
              <span class="right">{{ taskInfo.taskSuccessNum || 0 }}</span>
            </li>
            <li class="line">
              <span class="l" :title="$t('dms_task_detail_drawer.zhi_xing_shi_bai')">
                {{ $t('dms_task_detail_drawer.zhi_xing_shi_bai') }}
              </span>
              <span class="progress">
                <el-progress :percentage="(taskInfo.taskFailedNum / taskInfo.taskTotalNum) * 100" :format="progressFormat"
                  color="#FF5C5B"></el-progress>
              </span>
              <span class="right">{{ taskInfo.taskFailedNum || 0 }}</span>
            </li>
            <li class="line">
              <span class="l" :title="$t('Common.com_cancel')">
                {{ $t('Common.com_cancel') }}
              </span>
              <span class="progress">
                <el-progress :percentage="(taskInfo.taskCancelNum / taskInfo.taskTotalNum) * 100" :format="progressFormat"
                  color="#98A6AD"></el-progress>
              </span>
              <span class="right">{{ taskInfo.taskCancelNum || 0 }}</span>
            </li>
          </div>
        </div>
        <div class="table-box">
          <div class="table-container">
            <h2 class="table-title">
              {{ $t('dms_task_detail_drawer.zhi_ling_xin_xi') }}
            </h2>
            <custom-table class="table" tableCode="isp_task_detail_instruct" :data="contentList">
            </custom-table>
          </div>
          <div class="table-container">
            <h2 class="table-title">
              {{ $t('dms_task_detail_drawer.xiang_ying_xin_xi') }}
            </h2>
            <custom-table class="table" tableCode="isp_task_detail_response" :data="responseTableList">
            </custom-table>
          </div>


        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
// import firmwareTaskDetailFirmwareTable from './firmwareTask_detail_firmwareTable';
// import firmwareTaskDetailDeviceTable from './firmwareTask_detail_deviceTable';

export default {
  mixins: [dialogMixins],
  components: {
    // firmwareTaskDetailFirmwareTable,
    // firmwareTaskDetailDeviceTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },

  },
  computed: {
    // taskId: [Number, String]
    taskInfo() {
      return this.model.data || {};
    }
  },

  data() {
    return {
      visible: false,
      taskId: '',
      info: {
        firmwareInfo: {
          // firmwareType: ''
        },
      },
      paramTableColumn: [],

      tslContent: [],
      isconfigBill: false,
      // 字典name值
      iot_cmd_task_service_type: {},
      progressFlagTimeOut: null,
      // 账单期数
      responseTableList: [],
      contentList: [],
      commandMode: null,
    };
  },
  mounted() {
    this.initDialog();
    this.init();
  },
  destroyed() {

  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });

    },
    progressFormat: function (percentage) {
      return percentage === '';
    },

    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },
    init() {
      const reqData = {
        simTaskId: this.model.data.simTaskId,
      };
      this.$getJSON(apis.simIspTaskDetail, reqData).then((res) => {
        const tableList = Array.isArray(res.data) ? res.data : res.data.list;
        this.responseTableList = [...tableList];
        this.contentList = [...tableList];
      });
    },
  },
};
</script>

<style lang="scss">
.isp-task-detail-drawer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed !important;

  span[role='heading']:focus {
    outline: none;
  }

  .el-drawer__header {
    padding: 0;
    padding-left: 18px;
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    border-bottom: 1px solid #e9ebec;
    margin-bottom: 0;
    padding-right: 20px;

    .el-icon-close {
      font-size: 14px;
      font-weight: bold;
    }
  }

  .el-drawer__body {
    position: relative;
    padding: 0px;

    .info-content {
      display: flex;
      flex-direction: column;
      height: 100%;

      .info-content-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        padding: 0px !important;

        .info-box {
          flex: 0 0 300px;
          width: 300px;
          padding: 0 24px 24px;
          // margin-right: 24px;
          background-color: #f8f9fb;

          // height: 100%;
          .title {
            height: 70px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(57, 70, 104, 1);
            line-height: 70px;
          }

          .information {
            .line {
              height: 40px;
              line-height: 40px;
              background: rgba(255, 255, 255, 0);
              border-bottom: 1px solid rgba(238, 242, 247, 1);
              font-size: 12px;
              color: rgba(108, 117, 125, 1);

              span {
                float: right;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
              }
            }

            .line-break {
              p {
                height: 40px;
                line-height: 40px;
                background: rgba(255, 255, 255, 0);
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
              }

              span {
                font-size: 12px;
                color: rgba(152, 166, 173, 1);
                line-height: 17px;
                padding-bottom: 11px;
                border-bottom: 1px solid rgba(238, 242, 247, 1);
              }
            }
          }

          .device-num {
            height: 60px;
            font-size: 12px;
            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 60px;
            margin-top: 10px;

            span {
              float: right;
              height: 60px;
              font-size: 12px;
              font-weight: bold;
              color: rgba(73, 80, 87, 1);
              line-height: 60px;
            }
          }

          .device {
            .line {
              height: 36px;
              line-height: 36px;
              display: flex;

              .l {
                width: 60px;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .progress {
                flex: 0 0 155px;
                margin: 0 auto;
                height: 6px;

                // line-height: 36px;
                .el-progress {
                  padding: 11px 0;
                  width: 155px;
                }
              }

              .right {
                height: 36px;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
                line-height: 36px;
              }
            }
          }
        }

        .table-box {
          padding: 0 24px 24px;
          box-sizing: border-box;
          margin-bottom: 20px;
          // height: 0;
          flex: 1;
          overflow-y: auto;
          display: flex;
          flex-direction: column;

          .table-title {
            height: 60px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 60px;
          }

          .title {
            height: 40px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(57, 70, 104, 1);
            line-height: 40px;
          }

          .table-container {
            display: flex;
            flex-direction: column;
            flex: 1;

            .table {
              flex: 1;
              overflow: hidden;
            }
          }
        }
      }
    }
  }

  .drawer__footer {
    padding: 16px 24px;
    border-top: 1px solid #e9ebec;
    box-sizing: border-box;
  }
}
</style>
